"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchUserDirectory = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useFetchUserDirectory = (userType) => {
    const { userDirectory } = (0, react_1.useContext)(context_1.UserDirectoryContext);
    return userDirectory.filterUserDirectory({
        userType,
        userRole: [],
    });
};
exports.useFetchUserDirectory = useFetchUserDirectory;
